import { loadControllers } from './loadControllers.js';
import automaticControllers from 'virtual:stimulus-controllers';
import 'vite/modulepreload-polyfill';
import './globals.js';
import 'htmx-ext-json-enc';
import 'htmx-ext-response-targets';
import './vpnDataBootstrap.js';
import './handleBanner.js';
import './snackbar.js';
import './commonActions.js';
import './iosKeyboardFallback.js';

import { Application } from '@hotwired/stimulus';

// These core controllers install DOMContentLoaded handlers before the event fires.
import { AnalyticsController } from './controllers/tracking/analytics/analyticsController.js';
import { LoggingController } from './controllers/tracking/logging/loggingController.js';
import { MindboxController } from './controllers/tracking/mindbox/mindboxController.js';
import { SentryController } from './controllers/sentryController.js';
import { HtmxLinkGuardController } from './controllers/htmxLinkGuardController.js';
import { HandleHTMXEventsController } from './controllers/utm/handleHTMXEventsController.js';
import { SessionManagerController } from './controllers/session/sessionManagerController.js';
import { VpnDataController } from './controllers/vpnDataController.js';

const application = window.Stimulus || Application.start();
window.Stimulus = application;
const eagerControllers = {
    analytics: AnalyticsController,
    logging: LoggingController,
    mindbox: MindboxController,
    'sentry-init': SentryController,
    'htmx-link-guard': HtmxLinkGuardController,
    'handle-htmx-events': HandleHTMXEventsController,
    'session-manager': SessionManagerController,
    'vpn-data': VpnDataController,
};

// Legacy template names override automatically discovered identifiers.
const controllerOverrides = {
    chatsSse: () => import('./controllers/chats/chatSseController.js').then(m => m.ChatSseController),
    'respect-company-tabs': () =>
        import('./controllers/respects/companyTabsController.js').then(m => m.RespectsCompanyTabsController),
    'education-degree': () => import('./controllers/education/degreeController.js').then(m => m.DegreeController),
    'education-degree-modal': () =>
        import('./controllers/education/degreeModalController.js').then(m => m.DegreeModalController),
    'education-specialization': () =>
        import('./controllers/education/specializationController.js').then(m => m.SpecializationController),
    'education-date-picker': () =>
        import('./controllers/education/datePickerController.js').then(m => m.DatePickerController),
    'education-university': () =>
        import('./controllers/education/universityController.js').then(m => m.UniversityController),
    'education-organization': () =>
        import('./controllers/education/organizationController.js').then(m => m.OrganizationController),
    'education-faculty': () => import('./controllers/education/facultyController.js').then(m => m.FacultyController),
    'education-course': () => import('./controllers/education/courseController.js').then(m => m.CourseController),
    'education-summary': () => import('./controllers/education/summaryController.js').then(m => m.SummaryController),
    'education-additional-summary': () =>
        import('./controllers/education/additionalSummaryController.js').then(m => m.AdditionalSummaryController),
    'education-create-manager': () =>
        import('./controllers/education/createManagerController.js').then(m => m.CreateManagerController),
    'education-additional-manager': () =>
        import('./controllers/education/additionalManagerController.js').then(m => m.AdditionalManagerController),
};

for (const [name, controller] of Object.entries(eagerControllers)) {
    application.register(name, controller);
    delete automaticControllers[name];
}

loadControllers(application, automaticControllers, controllerOverrides);

window.stimulusControllersLoaded = true;
